// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/lightbulb.js';

import { paths } from '../generated/lightbulb';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('lightbulb', Original, paths);
